"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleRedirectPath = getLocaleRedirectPath;
function getLocaleRedirectPath({ pathname, preferredLanguage, supportedLocales = ["en", "es"], defaultLocale = "en", }) {
    // Guard: pathname must be a non-empty string
    if (!pathname || typeof pathname !== "string") {
        return null;
    }
    // Special handling for root path
    if (pathname === "/") {
        if (preferredLanguage &&
            preferredLanguage !== defaultLocale &&
            supportedLocales.includes(preferredLanguage)) {
            return `/${preferredLanguage}`;
        }
        return null;
    }
    // Guard: preferredLanguage must be a non-empty string and in supportedLocales
    if (!preferredLanguage || !supportedLocales.includes(preferredLanguage)) {
        return null;
    }
    const segments = pathname.split("/").filter(Boolean);
    const possibleLocale = segments[0];
    if (possibleLocale === preferredLanguage) {
        return null;
    }
    if (preferredLanguage &&
        preferredLanguage !== defaultLocale &&
        supportedLocales.includes(preferredLanguage)) {
        return `/${preferredLanguage}${pathname}`;
    }
    return null;
}
